import { css } from '@emotion/react';
import { ChangeEvent, ReactNode, useState } from 'react';
import Typography, { TypographyVariants } from '../text/Typography';
import { colors } from '../../../utils/styleguide';

type Props = {
  checked?: boolean;
  defaultValue?: boolean;
  label?: ReactNode;
  onChange?: (checked: boolean) => void;
  className?: string;
  variant?: TypographyVariants;
  disabled?: boolean;
  uncheckedBackgroundColor?: string;
  useBuiltInMargins?: boolean;
  color?: string;
};

export default function Checkbox({
  checked,
  onChange,
  defaultValue,
  label,
  className,
  variant,
  disabled,
  uncheckedBackgroundColor,
  useBuiltInMargins = true,
  color,
}: Props) {
  const [internalValue, setInternalValue] = useState(defaultValue || false);
  const value = checked === undefined ? internalValue : checked;

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInternalValue(event.target.checked);
    if (onChange) {
      onChange(event.target.checked);
    }
  };

  return (
    <div className={className}>
      <label
        css={css`
          display: inline-flex;
          align-items: center;
        `}
      >
        <input
          type="checkbox"
          checked={value}
          onChange={handleInputChange}
          css={css`
            display: none;
          `}
          disabled={disabled}
        />
        <div
          css={css`
            background-color: ${value
              ? `${colors.purple400}`
              : uncheckedBackgroundColor || `${colors.grey02}`};
            border-radius: 2px;
            box-sizing: border-box;
            height: 24px;
            width: 24px;
            min-height: 24px;
            min-width: 24px;
            padding: 3px;
          `}
        >
          {value && (
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 4.5L6.75 12.75L3 9"
                stroke={colors.white}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <Typography
          useBuiltInMargins={useBuiltInMargins}
          variant={variant ? variant : `bodySmall`}
          css={css`
            padding-left: 16px;
          `}
          color={color}
        >
          {label}
        </Typography>
      </label>
    </div>
  );
}
